// extracted by mini-css-extract-plugin
export default {"timeDiv":"unit-text_timeDiv__TqkXQ","unitText":"unit-text_unitText__3xAc-"};